import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

const Home: React.FC = () => {
  const tools = [
    {
      title: '图片转PDF',
      description: '将多张图片合并成一个PDF文件，支持拖拽上传和批量处理',
      path: '/image-to-pdf',
      icon: '📄'
    },
    {
      title: 'IP地址查询',
      description: '查询IP地址的地理位置、ISP信息和其他详细信息',
      path: '/ip-lookup',
      icon: '🌐'
    },
    {
      title: 'JSON格式化',
      description: '格式化、验证和美化JSON数据，支持语法高亮',
      path: '/json-formatter',
      icon: '📋'
    },
    {
      title: 'XML格式化',
      description: '格式化、验证和美化XML数据，支持语法检查',
      path: '/xml-formatter',
      icon: '📝'
    },
    {
      title: '图片格式转换',
      description: '在线转换图片格式，支持JPG、PNG、WebP等多种格式',
      path: '/image-converter',
      icon: '🖼️'
    },
    {
      title: 'Favicon制作',
      description: '在线制作网站图标，支持多种尺寸和格式输出',
      path: '/favicon-maker',
      icon: '⭐'
    }
  ];

  return (
    <div className="home-container">
      <SEO 
        title="AI工具箱 - 免费在线工具集合"
        description="AI工具箱提供多种免费在线工具：图片转PDF、IP地址查询、JSON/XML格式化、图片格式转换、Favicon制作等，无需注册，即开即用。"
        keywords="AI工具箱,免费在线工具,图片转PDF,IP查询,JSON格式化,XML格式化,图片转换,Favicon制作"
      />
      <h1 className="home-title">AI工具箱</h1>
      <p className="home-subtitle">
        集合多种实用在线工具，提升您的工作效率
      </p>
      
      <div className="tools-grid">
        {tools.map((tool, index) => (
          <Link key={index} to={tool.path} className="tool-card">
            <div style={{ fontSize: '3rem', marginBottom: '15px' }}>
              {tool.icon}
            </div>
            <h3>{tool.title}</h3>
            <p>{tool.description}</p>
          </Link>
        ))}
      </div>
      
      <div style={{ marginTop: '60px', padding: '30px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        <h2 style={{ color: '#2c3e50', marginBottom: '20px' }}>特色功能</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
          <div>
            <h4 style={{ color: '#667eea', marginBottom: '10px' }}>🚀 快速处理</h4>
            <p style={{ color: '#7f8c8d' }}>所有工具都在浏览器本地运行，处理速度快，保护隐私</p>
          </div>
          <div>
            <h4 style={{ color: '#667eea', marginBottom: '10px' }}>🔒 安全可靠</h4>
            <p style={{ color: '#7f8c8d' }}>数据不上传到服务器，完全在本地处理，确保数据安全</p>
          </div>
          <div>
            <h4 style={{ color: '#667eea', marginBottom: '10px' }}>📱 响应式设计</h4>
            <p style={{ color: '#7f8c8d' }}>支持各种设备，手机、平板、电脑都能完美使用</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;